module.exports = __webpack_public_path__ + "static/media/title_report.05a88dc6.svg";